import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { shippingMethodStyles } from "@store/Overrides/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { checkoutInfoGridProps, checkoutSubtitleProps } from "@store/theme/common/props/checkout";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { FC, useContext } from "react";

const RequestedDate = getWidgetComponent("OrderDetails/OrderDetailsRequestedDate");
const ShippingAddress = getWidgetComponent("OrderDetails/OrderDetailsShippingAddress");
const ShippingMethod = getWidgetComponent("OrderDetails/OrderDetailsShippingMethod");

interface Props {}

export interface StoreOrderShippingInformationStyles {
    title?: TypographyProps;
    gridContainer?: GridContainerProps;
    addressGridItem?: GridItemProps;
    infoGridItem?: GridItemProps;
    infoGridContainer?: GridContainerProps;
    methodGridItem?: GridItemProps;
    dateRequestedGridItem?: GridItemProps;
}

export const storeOrderShippingInformationStyles: StoreOrderShippingInformationStyles = {
    title: checkoutSubtitleProps,
    gridContainer: checkoutInfoGridProps.container,
    addressGridItem: checkoutInfoGridProps.item,
    infoGridItem: checkoutInfoGridProps.largeItem,
    infoGridContainer: checkoutInfoGridProps.container,
    methodGridItem: checkoutInfoGridProps.largeSubItem,
    dateRequestedGridItem: checkoutInfoGridProps.largeSubItem,
};

const styles = storeOrderShippingInformationStyles;

const StoreOrderShippingInformation: FC<Props> = () => {
    const { value: order } = useContext(OrderStateContext);
    const noShipCodeValue = "No Desc"; // Poolcorp Custom Code

    if (!order) {
        return null;
    }

    // Poolcorp Removed Code - hasShippingMethod

    return (
        <>
            <Typography {...styles.title}>{translate("Shipping Information")}</Typography>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.addressGridItem}>
                    <ShippingAddress />
                </GridItem>
                <GridItem {...styles.infoGridItem}>
                    <GridContainer {...styles.infoGridContainer}>
                        {order.shipViaDescription ||
                            (order.shipCode && order.shipCode !== noShipCodeValue && (
                                <GridItem {...styles.methodGridItem}>
                                    <ShippingMethod />
                                </GridItem>
                            ))}
                        {order.requestedDeliveryDateDisplay && (
                            <GridItem {...styles.dateRequestedGridItem}>
                                <RequestedDate />
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </>
    );
};

export default StoreOrderShippingInformation;
